module.exports = __webpack_public_path__ + "static/soc5-04d1ca5ccfee8027ac7401529de367ef.png";